import React from "react";
import "./Preloader.css";
import preloader from "../../assets/preloader.png"

const Preloader = ({ startWebsite }) => {
  return (
    <div className="preloader">

      <div className="preloaderContent">

        <img src={preloader} className="preloaderImage" />

        <div className="loadingDots">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <button
          className="enterButton"
          onClick={startWebsite}
        >
          Enter the Experience
        </button>

      </div>

    </div>
  );
};

export default Preloader;